export const ContentSection = ({ 
  children, 
  className = "",
  bgColor = "bg-white",
  containerClass = "max-w-7xl mx-auto px-6",
  paddingY = "py-16 md:py-24"
}) => {
  return (
    <section className={`${bgColor} ${paddingY} ${className}`}>
      <div className={containerClass}>
        {children}
      </div>
    </section>
  );
};

export const SectionHeader = ({ 
  title, 
  subtitle, 
  align = "center",
  className = ""
}) => {
  const alignClass = align === "center" ? "text-center" : "text-left";
  
  return (
    <div className={`${alignClass} mb-12 md:mb-16 ${className}`}>
      <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-primary-900 mb-4">
        {title}
      </h2>
      {subtitle && (
        <p className="text-lg md:text-xl text-slate-600 max-w-2xl mx-auto leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
};
